import React from 'react'
import BenefitsReceived from '../../componentsGeneral/componentsSuperUser/studentProfile/benefitsReceived/BenefitsReceived'

const BenefitsReceivedStudents = () => {
  return (
    <div>
        <BenefitsReceived/>
    </div>
  )
}

export default BenefitsReceivedStudents